import { brand, routes } from '../site';

/**
 * İletişim sayfası (/iletisim). Kaynak: "ZHesap Site İçerikleri - İletişim,
 * SSS, Partnerlik" metin dosyası, 1. bölüm.
 */
const mapsQuery = 'Dijital+Park+Teknokent+%C3%87ekmek%C3%B6y+%C4%B0stanbul';

export const iletisimPage = {
  href: routes.iletisim,
  hero: {
    eyebrow: 'İletişim',
    title: 'Konuşalım',
    lead: 'Demo talebinden iş birliğine, sorularından önerilerine kadar her konuda ekibimize ulaşabilirsin. Mesajlarına en geç 1 iş günü içinde dönüyoruz.',
  },
  cards: {
    email: { label: 'E-posta', value: brand.email, href: `mailto:${brand.email}`, note: 'Her konuda bize yaz' },
    phone: {
      label: 'Telefon',
      value: brand.phone,
      href: brand.phoneHref,
      // Metin dosyasında saatler "onaylanacak" olarak işaretli.
      note: 'Hafta içi 09:00 – 18:00',
    },
    address: {
      label: 'Adres',
      value: brand.address,
      detail: brand.addressDetail,
      directions: { label: 'Yol tarifi al', href: `https://www.google.com/maps/search/?api=1&query=${mapsQuery}` },
    },
  },
  routing: {
    title: 'Doğru kişiye hızlıca ulaş',
    items: [
      {
        title: 'ZHesap’ı görmek mi istiyorsun?',
        desc: 'Demo görüşmesinde kendi verine nasıl uyduğunu gör.',
        cta: { label: '7 Gün Ücretsiz Dene', href: '/#erken-erisim' },
      },
      {
        title: 'Zaten müşterimiz misin?',
        desc: 'Destek taleplerini panelin içindeki destek alanından iletirsen kayıtların hesabınla eşleşir, daha hızlı çözeriz.',
        cta: { label: 'Panele Giriş Yap', href: brand.appUrl },
      },
      {
        title: 'Partner olmak mı istiyorsun?',
        desc: 'Ajans ve e-ticaret danışmanları için partner programımızı incele.',
        cta: { label: 'Partnerlik', href: routes.kurumsal.partnerlik },
      },
    ],
  },
  form: {
    title: 'Bize yaz',
    name: 'Ad Soyad',
    email: 'E-posta',
    emailPlaceholder: 'ornek@sirket.com',
    phone: 'Telefon',
    phonePrefix: '+90',
    phonePlaceholder: '5XX XXX XX XX',
    company: 'Şirket / Marka adı',
    optional: '(isteğe bağlı)',
    subject: 'Konu',
    subjectPlaceholder: 'Bir konu seç',
    subjects: ['Demo talebi', 'Satış ve fiyat', 'Destek', 'Partnerlik', 'Basın', 'Diğer'],
    message: 'Mesajın',
    marketing: 'ZHesap’tan kampanya, duyuru ve içerik e-postaları almak istiyorum.',
    submit: 'Mesajı Gönder',
    submitting: 'Gönderiliyor…',
    success: 'Mesajın bize ulaştı. En geç 1 iş günü içinde sana dönüş yapacağız.',
    again: 'Yeni mesaj gönder',
    errors: {
      required: 'Bu alan zorunlu.',
      email: 'Geçerli bir e-posta adresi gir.',
      phone: 'Geçerli bir telefon numarası gir. Örn: 532 123 45 67',
      subject: 'Bir konu seç.',
      summary: 'Lütfen yıldızlı alanları doldur ve KVKK onayını işaretle.',
      send: 'Mesajın gönderilemedi. Lütfen tekrar dene.',
      /** {seconds} gönderim hakkının açılmasına kalan süreyle değiştirilir. */
      rateLimit: 'Çok sık gönderim yaptın. {seconds} saniye sonra tekrar deneyebilirsin.',
    },
  },
  map: {
    title: 'Dijital Park Teknokent',
    note: 'Harita Google Haritalar’dan yüklenir ve çerez kullanır; görüntülemek için butona bas.',
    button: 'Haritayı görüntüle',
    frameTitle: 'Dijital Park Teknokent konumu, Google Haritalar',
    embed: `https://www.google.com/maps?q=${mapsQuery}&output=embed`,
  },
} as const;
